import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import CardCustomerModel from "../../models/party/cardcustomer-model";

const url = getEndPoint(API_END_POINT.PARTY) +"/api/CardCustomer/GetAllCardCustomer";// //{/api/CardCustomer/GetAllCardCustomer}`)  //// "https://localhost:7054/api/CardCustomer/GetAllCardCustomer";
export const useGetCardCustomer = createQuery<
  CardCustomerModel[],
  null,
  AxiosError
>({
  queryKey: ["keyCardCustomerpage"],
  fetcher: (params) =>
        getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
   
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
